/**
 * Fonction de logout complet
 * Supprime toutes les données de session et redirige vers la page de login
 */
export const performLogout = () => {
  // Supprimer TOUT du localStorage
  localStorage.clear();
  
  // Supprimer TOUT du sessionStorage
  sessionStorage.clear();
  
  // Supprimer tous les cookies
  document.cookie.split(";").forEach((c) => {
    document.cookie = c
      .replace(/^ +/, "")
      .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
  });
  
  // Rediriger vers la page de connexion existante
  window.location.href = '/espace-membre';
};

/**
 * Fonction pour vérifier si l'utilisateur est authentifié
 */
export const isAuthenticated = () => {
  const authToken = localStorage.getItem('authToken');
  const currentUser = localStorage.getItem('currentUser');
  return !!(authToken || currentUser);
};

/**
 * Fonction pour obtenir les informations de l'utilisateur courant
 */
export const getCurrentUser = () => {
  const currentUser = localStorage.getItem('currentUser');
  if (currentUser) {
    try {
      return JSON.parse(currentUser);
    } catch (e) {
      console.error('Error parsing currentUser:', e);
      return null;
    }
  }
  return null;
};
